import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroBanner() {
  return <section data-section-id="256073" id="hero-banner" className="relative w-full h-screen min-h-[600px] flex items-center justify-center bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sustainability_industrial_landscape.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sustainability_industrial_landscape.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/sustainability_industrial_landscape.png-wvc-sizes" alt="Compromiso con la Sostenibilidad Industrial" className="w-full h-full object-cover" loading="lazy" decoding="async" />
        {}
        <div className="absolute inset-0 bg-primary-900/40 backdrop-blur-[2px]"></div>
      </div>

      {}
      <div className="relative z-10 bg-background/90 border-l-4 border-b-4 border-primary p-10 md:p-16 flex flex-col items-center text-center max-w-lg mx-4 shadow-2xl">
        <Link to="/HomePage" className="mb-8 block">
          <img src="/img/kalisch_acero_logo_sustainability.png" alt="Kalisch Acero Logo" className="h-24 object-contain" />
        </Link>

        <h1 className="text-4xl md:text-5xl lg:text-6xl text-foreground font-default mb-10 leading-tight tracking-wide">
          Forjando un<br />Futuro Verde
        </h1>

        <Link to="/SustainabilityPage">
          <Button size="lg" className="bg-primary hover:bg-primary-600 text-primary-foreground rounded-md px-10 py-6 text-sm tracking-widest uppercase border-none shadow-md transition-colors duration-300 font-default">
            Nuestro Impacto
          </Button>
        </Link>
      </div>
    </section>;
}